import React, { useState, useEffect, useRef } from "react";
import cer from "assests/About/ISO/i2.jpg";
import Container from "Components/Container/Container";
const Landing = () => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Adjust the threshold as needed
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      });
    }, options);

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="">
      <Container>
        <div className="flex flex-col mb-32 lg:mb-14  gap-y-6 px-6 md:px-10 lg:px-0 gap-x-12 w-full items-center lg:flex-row lg:even:flex-row-reverse scroll-section ">
          <div className="flex-1 relative">
            <div
              className={`hidden lg:block absolute transition ease-in duration-700 w-full lg:h-[80vh] inset-0 bg-black opacity-80  mix-blend-multiply ${
                visible ? "translate-y-[100%]" : "translate-y-[0%]"
              }`}
            ></div>
            <img
              className={` lg:h-[80vh]  mx-auto lg:object-contain transition ease-in duration-300`}
              src={cer}
              alt=""
            />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Landing;
